import { render } from "./receiverConfig.vue?vue&type=template&id=06177218"
import script from "./receiverConfig.vue?vue&type=script&lang=js"
export * from "./receiverConfig.vue?vue&type=script&lang=js"

import "./receiverConfig.vue?vue&type=style&index=0&id=06177218&lang=scss"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__